module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cx-2da85ddc623ba4f3a90bd3d04e1d3ec5.svg";